<div class="auth-body h-screen">
  <div class="grid lg:grid-cols-2 h-full">
    <div class="bg-slate-200 hidden lg:flex items-center justify-end">
      <div class="bg-white h-4/6 w-8/12 p-1 drop-shadow-lg">
        <img
          class="h-full w-full object-cover"
          src="https://images.unsplash.com/photo-1641759796228-2479fca98bf2?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1174&q=80"
          alt="" />
      </div>
    </div>
    <div class="lg:bg-primary flex items-center justify-start">
      <div
        class="lg:bg-white w-full lg:h-4/6 lg:w-8/12 drop-shadow-lg flex items-center justify-center">
        <div class="w-100 w-8/12 lg:w-7/12 text-center lg:text-start">
          <nz-card class="border-0">
            <div class="mb-4">
            </div>
            <div>
              <form nz-form class="otp-form">
                <div class="mb-3">
                  <h4 class="mb-3">OTP Verification</h4>
                  <p class="text-justify">
                    Please check your email and enter the verification code that you
                    received.
                  </p>
                </div>
                <div class="flex justify-center">
                  <div class="mb-3">
                    <nz-form-item class="my-3 text-center">
                      <nz-form-control>
                        <ng-otp-input
                          (onInputChange)="onOtpChange($event)"
                          [config]="config"></ng-otp-input>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                </div>
                <div class="flex justify-end forgotPwd">
                  <span><a (click)="resendOtp()">Resend OTP</a></span>
                </div>

                <div class="">
                  <div class="mt-3">
                    <button
                      [disabled]="otpValue.toString().length !== 4"
                      nz-button
                      nzType="primary"
                      class="my-3"
                      nzBlock
                      (click)="verifyOtp()">
                      Verify
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </nz-card>
        </div>
      </div>
    </div>
  </div>
</div>
